import { render, staticRenderFns } from "./car-add.vue?vue&type=template&id=24f4c5e4&scoped=true&"
import script from "./car-add.vue?vue&type=script&lang=js&"
export * from "./car-add.vue?vue&type=script&lang=js&"
import style0 from "./car-add.vue?vue&type=style&index=0&id=24f4c5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f4c5e4",
  null
  
)

export default component.exports